import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import {
  ThemeProvider,
  createTheme,
  CssBaseline,
  CircularProgress,
} from "@mui/material";
import SuccessScreen from "screens/Questionnaire/components/form-submittion-state/SuccessScreen";
import VoiceAgent from "screens/VoiceAgents/VoiceAgent";
import MIAgent from "screens/Questionnaire/components/agents/MIAgent";

// Lazy-loaded components
const Questionnaire = lazy(
  () => import("../screens/Questionnaire/Questionnaire"),
);
const MainLayout = lazy(() => import("../layout/mainLayout"));
const NotFound = lazy(() => import("../screens/NotFound"));

// Custom theme
const theme = createTheme({
  palette: {
    primary: { main: "#446566" }, // buttons, links, etc.
    secondary: { main: "#FF9F0A" },
  },
  typography: {
    fontFamily: "Poppins, sans-serif",
    fontSize: 10, //0.625rem
  },
  components: {
    MuiIconButton: {
      defaultProps: {
        color: "primary",
      },
    },
  },
});

const AppRoutes = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Suspense
        fallback={
          <div className="h-100 d-flex justify-content-center align-items-center">
            <CircularProgress />
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<NotFound />} />
          {/* <Route path="/" element={<MainLayout />}> */}
          <Route path="/">
            {/* <Route path="/ui/:tenantId/formLink/:formId" element={<Questionnaire />} /> */}
            {/* <Route path="/patient-intake" element={<Questionnaire />} /> */}
            <Route path="/patient-intake/tenant/:tenantId/formLink/:sha" element={<Questionnaire />} />
            <Route path="/success" element={<SuccessScreen />} />
            <Route
              path="/web-agent"
              element={<VoiceAgent typeOfAgent="web" />}
            />
            <Route
              path="/web-agent/version-2"
              element={<VoiceAgent typeOfAgent="web" version={2} />}
            />
            <Route
              path="/web-agent/version-3"
              element={<VoiceAgent typeOfAgent="web" version={3} />}
            />
            <Route
              path="/web-agent/version-4"
              element={<VoiceAgent typeOfAgent="web" version={4} />}
            />
            <Route
              path="/voice-agent"
              element={<VoiceAgent typeOfAgent="phone" />}
            />
            <Route path="/mia" element={<MIAgent />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </ThemeProvider>
  );
};

export default AppRoutes;
